import Title from "./Title";

export default function ContactSection() {

    return (
        <section className="mx-auto text-center py-10 sm:py-16 " id="contact">
            <Title
                className="!pb-0 sm:!pb-6"
                title={"Contact"}
                linkableID={"contact"}
            />
            <p className="mb-10 text-base lg:text-lg">Heeft u vragen over dit project? <br />
                Ons contactpersoon is Isis Ton, te bereiken via LinkedIn of e-mail.
            </p>
            <a href="mailto:1036029@hr.nl" target="_blank" className="bg-gradient-to-r from-[#FE6D00] to-orange-400 text-white px-3 font-bold py-2 rounded-md">Mail naar 1036029@hr.nl</a>
        </section>
    )
}